import React from 'react';
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container';
import { ReactComponent as BgImage } from "../../../assets/images/blog/fundo.svg";
import Carousel from '../../UI/Carousel/Carousel';
import Button from '../../UI/Button/Button';
import BlogItem from './BlogItem';
import { Link } from 'react-router-dom';

const Blog = props => {

    const blogContent = props.i18n.getResource(props.i18n.language, 'blog')['news'];
    let blogArray= Object.keys(blogContent).reduce((array, key) => {
        const content = {...blogContent[key], key: key};

        return [...array, content ];
    }, [])
    
    let articles = blogArray.map( (article, key) => (
        <BlogItem 
            key={key}
            src={require("../../../assets/images/blog/" + article["content"]["image"].name+ ".png").default}
            srcWebp={require("../../../assets/images/blog/" + article["content"]["image"].name+ ".webp").default}
            alt={article["content"]["title"]}
            title={article["content"]["title"]}
            summary = {article["content"]["summary"]}
            link = {article['link'] ? article['link'] : props.t('routes:blog.path') + '/' + article['key']} 
        />
    ));

    return(
        <section id="blog" className="my">
            <BgImage className="blog-bg d-none d-md-block"/>
            <Container>
                <div className="blog-content">
                    <div className="title-triangle top-sm"></div>
                    <h2 className="h4 fw-600 black">
                        {props.t("blog:title")}
                    </h2>
                    <Carousel className="blog-slide">
                        {articles}
                    </Carousel>
                    <Row className="justify-content-center">
                        <Link to={props.t('routes:blog.path') + "#top"}>
                            <Button btnClasses={'p-l h5 fw-600 text-uppercase mt-5 mt-md-0'}> {props.t("blog:btn")} </Button>
                        </Link>
                    </Row>
                </div>
            </Container>
        </section>
    )
};

export default Blog;

